// src/assets/qr-import.js
// Inject the donate/support QR code into the donate panel. Two modes:
//
//   EN: Stripe donate button + general QR code + "Scan to donate" label
//   ZH: WeChat QR code only + WeChat follow message, Stripe button hidden
//
// Switches automatically on locale change via onLocaleChange.

import qrUrl from './qr_28E28q8mxayRduU4Htg3601.png';
import qrWechatUrl from './qr_wechat.png';
import { t, getLocale, onLocaleChange } from '../i18n.js';

function buildDonateContent() {
  const panel = document.querySelector('.donate-panel');
  if (!panel) return;

  // Clear the panel completely — we rebuild for the current locale.
  panel.innerHTML = '';

  const isZh = getLocale() === 'zh';

  if (isZh) {
    // Chinese mode: WeChat QR code + follow message. No Stripe button.
    const wrap = document.createElement('div');
    wrap.className = 'donate-qr';

    const img = document.createElement('img');
    img.src = qrWechatUrl;
    img.alt = 'WeChat QR';
    img.className = 'donate-qr-img';
    img.width = 200;
    img.height = 200;

    const label = document.createElement('p');
    label.className = 'donate-label';
    label.textContent = t('donate.wechatMsg');

    wrap.appendChild(img);
    wrap.appendChild(label);
    panel.appendChild(wrap);
  } else {
    // English mode: Stripe button + general QR + "Scan to donate".
    // Recreate the Stripe button element so Stripe's SDK can upgrade it.
    const msg = document.createElement('p');
    msg.className = 'donate-label';
    msg.textContent = t('donate.message');
    panel.appendChild(msg);

    const wrap = document.createElement('div');
    wrap.className = 'donate-qr';

    const img = document.createElement('img');
    img.src = qrUrl;
    img.alt = 'Donate QR code';
    img.className = 'donate-qr-img';
    img.width = 140;
    img.height = 140;

    const qrLabel = document.createElement('p');
    qrLabel.className = 'donate-qr-label';
    qrLabel.textContent = t('donate.scanLabel');

    wrap.appendChild(img);
    wrap.appendChild(qrLabel);
    panel.appendChild(wrap);

    const stripeBtn = document.createElement('stripe-buy-button');
    stripeBtn.setAttribute('buy-button-id', 'buy_btn_1Ti50BCkFgrgzYoFU29pYOif');
    stripeBtn.setAttribute('publishable-key', 'pk_live_51TPv3eCkFgrgzYoFVP26aHUbYMHypC20ZkyFv7Tve8Z9X48fjN4Vhqn54k65RQCsCucbhIRUR7M05JSdbdMjGUIj00at7STWdu');
    panel.appendChild(stripeBtn);
  }
}

// Run once on load.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => buildDonateContent());
} else {
  buildDonateContent();
}

// Rebuild the entire panel when the locale changes — Stripe button vs
// WeChat QR is a mode switch, not just a text swap.
onLocaleChange(() => buildDonateContent());
